export const fontSize = {
    isMobile480: "14px",
    isTablet768: "16px",
    isTablet1024: "20px",
    isLaptopDesktop: "20px",
  };